// extracted by mini-css-extract-plugin
export default {"footer":"ConfigZone_footer__S2ITh","btn-save":"ConfigZone_btn-save__EFq6a","btn-cancle":"ConfigZone_btn-cancle__P8Whv","modal_loading":"ConfigZone_modal_loading__j+9MP"};